import { render, staticRenderFns } from "./division-label.vue?vue&type=template&id=4a6d448f&scoped=true"
import script from "./division-label.vue?vue&type=script&lang=js"
export * from "./division-label.vue?vue&type=script&lang=js"
import style0 from "./division-label.vue?vue&type=style&index=0&id=4a6d448f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6d448f",
  null
  
)

export default component.exports